<script>
  import "@github/clipboard-copy-element"

  export let label
  export let value
  export let successText = "Copied!"
  export let timeOut = 1500
  export let underlined = true

  let showSuccess = false

  function onCopy() {
    showSuccess = true
    setTimeout(() => {
      showSuccess = false
    }, timeOut)
  }
</script>

<div class="root" class:underlined>
  <clipboard-copy {value} on:clipboard-copy={onCopy} hidden={showSuccess}>
    {label}
  </clipboard-copy>
  <span class="notice" hidden={!showSuccess}>{successText}</span>
</div>

<style>
  .root {
    display: flex;
  }

  .underlined clipboard-copy {
    text-decoration: underline;
    text-underline-offset: 0.1em;
  }

  clipboard-copy {
    cursor: pointer;
  }
</style>
